import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Alert, ErrorScreen } from 'components/common';
import { useCompany, useUser } from 'components/hooks';
import { ROUTES } from 'consts';
import { formatProjectItems } from 'helpers';
import withRequest from 'hoc/withRequest';
import { useHistory, withRouter } from 'react-router-dom';
import { CompanySchema } from 'schemas';
import { CircularProgress, Backdrop } from '@mui/material';
import CompanyFormDumb from './CompanyFormDumb';


const CompanyEditSmart = (props) => {
  const { match: { params } } = props;
  const { companyId } = params;
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const history = useHistory();
  const { cleanUpMessage, error, success, putCompany, getCompany, data, isLoaded } = useCompany();

  const [defaultValues, setDefaultValues] = useState({
    name: '',
    project: projects[0].value,
    additionalVariables: ''
  });

  useEffect(() => {
    if (!!success.put) {
      history.push(ROUTES.COMPANY_LIST);
    } else if (!!success.get) {
      handleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success.get, success.put]);

  useLayoutEffect(() => {
    const query = {
      companyId
    }
    getCompany({ query });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseAlert = () => cleanUpMessage();

  const handleEdit = (data) => {
    const company = new CompanySchema();
    company.setValues(data);
    company.values.company_id = Number(companyId);
    putCompany({ body: company.getValues() });
  };

  function handleData() {
    const dataToSet = {
      name: data.name,
      description: data.description,
    }
    setDefaultValues(dataToSet);
  };

  return (
    <>
      { error.get ?
        (
          <ErrorScreen />
        ): isLoaded.get ?
          (
            <Backdrop
              invisible
              sx={{ zIndex: (theme) => theme.zIndex.drawer - 1 }}
              open={true}
            >
              <CircularProgress color="primary" />
            </Backdrop>
          ): (data && projects) ?
            (
              <CompanyFormDumb
                defaultValues={defaultValues}
                handleOnSubmit={handleEdit}
                isEdit={true}
              />
            )
            :(
              <ErrorScreen />
            )
      }
      <Alert severity="error" handleClose={handleCloseAlert} open={error.put} message="common.errors.general.title" />
    </>
  );
};

export default withRequest(withRouter(CompanyEditSmart));
